import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Toast } from "@/shared/ui";

interface Props {
  dismissKey: string;
  textKey: string;
  additionalTextKey?: string;
  hideFrom?: string;
}

function readDismissed(dismissKey: string): boolean {
  try {
    return localStorage.getItem(dismissKey) === "1";
  } catch {
    return false;
  }
}

function writeDismissed(dismissKey: string) {
  try {
    localStorage.setItem(dismissKey, "1");
  } catch {
    return;
  }
}

export default function AnnouncementBanner({ dismissKey, textKey, additionalTextKey, hideFrom }: Props) {
  const { t } = useTranslation("Common");
  const [isDismissed, setIsDismissed] = useState(() => readDismissed(dismissKey));

  function handleClose() {
    writeDismissed(dismissKey);
    setIsDismissed(true);
  }

  if (isDismissed || (hideFrom && Date.now() >= Date.parse(hideFrom))) return null;

  return (
    <div className="px-5 pt-3">
      <Toast
        color="notice"
        isFullWidth
        autoClose={false}
        closable
        text={t(textKey)}
        additionalText={additionalTextKey ? t(additionalTextKey) : undefined}
        onClose={handleClose}
      />
    </div>
  );
}
